import { LogEntry, LogLevel } from './log-entry';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class LoggingService {
    level: LogLevel = environment.MIN_LOG_LEVEL;
    logWithDate = true;

    debug(msg: string, ...optionalParams: any[]) {
        this.writeToLog(msg, LogLevel.Debug, optionalParams);
    }

    info(msg: string, ...optionalParams: any[]) {
        this.writeToLog(msg, LogLevel.Info, optionalParams);
    }

    warn(msg: string, ...optionalParams: any[]) {
        this.writeToLog(msg, LogLevel.Warn, optionalParams);
    }

    error(msg: string, ...optionalParams: any[]) {
        this.writeToLog(msg, LogLevel.Error, optionalParams);
    }

    fatal(msg: string, ...optionalParams: any[]) {
        this.writeToLog(msg, LogLevel.Fatal, optionalParams);
    }

    log(msg: string, ...optionalParams: any[]) {
        this.writeToLog(msg, LogLevel.All, optionalParams);
    }

    /**
     * Function which decides if the current log level is above the min log level set
     * @param level the current log level which the user want to use for logging a message
     * @returns boolean
     */
    private shouldLog(level: LogLevel): boolean {
        let ret = false;
        if ((level >= this.level && level !== LogLevel.Off) || this.level === LogLevel.All) {
            ret = true;
        }
        return ret;
    }

    /**
     * Function used for actually writting the log based on the level type
     * @param msg the message to log
     * @param level the type of log
     * @param params any extra data that the users wants to send for logging
     */
    private writeToLog(msg: string, level: LogLevel, params: any[]) {
        if (this.shouldLog(level)) {
            let entry: LogEntry = new LogEntry();
            entry.message = msg;
            entry.level = level;
            entry.extraInfo = params;
            entry.logWithDate = this.logWithDate;
            switch (level) {
                case LogLevel.Error: {
                    console.error(entry.buildLogString());
                    break;
                }
                case LogLevel.Warn: {
                    console.warn(entry.buildLogString());
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }
}
